import { Immutable } from "immer";
import React from "react";

import type { RightBarSection as Value } from "@reactivated";

// NOTE: This component reproduces the legacy server-rendered markup from
// `cms/components/right-bar-section.html` verbatim:
//
//     <h1 class="content__aside__title">{{ value.header }}</h1>
//     {{ value.body }}
//
// The legacy template had no outer wrapper element -- the `<aside
// class="content__aside">` wrapper lives in `utility_page.html` and the
// `.block-right_bar_section` wrapper comes from `{% include_block %}`. So this
// component renders only a Fragment of [<h1>, body]. The `content__aside__title`
// classname is load-bearing for the existing SCSS; keep it in sync.
type IProps = Immutable<{
    value: Value;
}>;

export const RightBarSection = (props: IProps): React.JSX.Element => {
    const v = props.value;
    return (
        <>
            {/* `header` is a plain CharBlock string -- the legacy template did
                NOT mark it `|safe`, so render as text to match Django's
                autoescape (null renders nothing, like an empty `{{ value.header }}`). */}
            <h1 className="content__aside__title">{v.header}</h1>
            {/* `body` is a server-rendered rich-text string that already
                includes the `<div class="rich-text">` wrapper (matching the
                legacy `{{ value.body }}` output on a RichTextBlock). Inject it
                verbatim; the `.content__aside .rich-text` SCSS rules are
                descendant selectors, so the intermediate (classless) div is
                harmless. */}
            <div dangerouslySetInnerHTML={{ __html: v.body ?? "" }} />
        </>
    );
};
